export const PAYPAL_TX_LOOKUP_REQUEST = "PAYPAL_TX_LOOKUP_REQUEST";
export const PAYPAL_TX_LOOKUP_SUCCESS = "PAYPAL_TX_LOOKUP_SUCCESS";
export const PAYPAL_TX_LOOKUP_ERROR = "PAYPAL_TX_LOOKUP_ERROR";
export const PAYPAL_TX_LOOKUP_RESET = "PAYPAL_TX_LOOKUP_RESET";
